export const noop = (terminal) => terminal;
//# sourceMappingURL=noop.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/x6/es/registry/connection-strategy/noop.js
// module id = null
// module chunks = 